import { AI_API_SNIPPET_SERVICE } from '@eggplant/api-hosts'
import { AuthenticatedDataRequest } from '@eggplant/data-request'
import type {
  Error,
  GetRubyFileOrSuiteParams,
  GetRubyFileOrSuiteResponse
} from '@eggplant/types'
import type { ReactElement } from 'react'

interface Props {
  params?: GetRubyFileOrSuiteParams
  children?: (data: GetRubyFileOrSuiteResponse) => ReactElement | ''
  onError?: (error: Error) => void
}

const GetRubySuites = ({
  params,
  children,
  onError
}: Props) => {
  const url = `${AI_API_SNIPPET_SERVICE}/suite`

  return (
    <AuthenticatedDataRequest
      children={children}
      method='get'
      onError={onError}
      params={params}
      url={url}
    />
  )
}

export default GetRubySuites
